import { useEffect, useState, useCallback } from 'react';
import waApi from '../../services/whatsapp/waApi';

// ─── Contrato do backend GET /dashboard/heatmaps (#62) ───────────────
// O backend ja devolve as faixas completas (24h, 7 dias, 31 dias do mes),
// inclusive com count=0, e agrega no fuso de Brasilia. weekday: 0=Seg..6=Dom.

export interface HeatHour {
  hour: number; // 0..23
  count: number;
}

export interface HeatWeekday {
  weekday: number; // 0=Seg..6=Dom
  count: number;
}

export interface HeatMonthday {
  day: number; // 1..31
  count: number;
}

// 'sem_permissao' quando o backend responde 403 (endpoint exige admin/supervisor).
// Mesmo padrao do useWaDashboardMetrics para o front tratar o caso sem permissao.
type HeatmapError = 'sem_permissao' | 'erro' | null;

function mapError(err: any): HeatmapError {
  return err?.response?.status === 403 ? 'sem_permissao' : 'erro';
}

/**
 * Mapas de calor das conversas — GET /dashboard/heatmaps?days=N (admin/supervisor).
 * Retorna as 3 agregacoes (hora/dia-da-semana/dia-do-mes) + loading/error.
 */
export function useWaHeatmapStats(days = 30) {
  const [byHour, setByHour] = useState<HeatHour[]>([]);
  const [byWeekday, setByWeekday] = useState<HeatWeekday[]>([]);
  const [byMonthday, setByMonthday] = useState<HeatMonthday[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<HeatmapError>(null);

  const fetch = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await waApi.get('/dashboard/heatmaps', { params: { days } });
      setByHour(Array.isArray(res.data?.by_hour) ? res.data.by_hour : []);
      setByWeekday(Array.isArray(res.data?.by_weekday) ? res.data.by_weekday : []);
      setByMonthday(Array.isArray(res.data?.by_monthday) ? res.data.by_monthday : []);
    } catch (err) {
      setError(mapError(err));
      setByHour([]);
      setByWeekday([]);
      setByMonthday([]);
    } finally {
      setIsLoading(false);
    }
  }, [days]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { byHour, byWeekday, byMonthday, isLoading, error, refetch: fetch };
}

export default useWaHeatmapStats;
